export default __webpack_public_path__ + "static/media/add-icon-white.7f3b937a.svg";